import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { Link } from 'react-router-dom'

import { ReactComponent as IconBack } from 'assets/icons/IconBack.svg'
import { ReactComponent as IconHamburger } from 'assets/icons/IconHamburger.svg'

const Navbar = props => {
  const { title, toggleSidebarActive, isFullNavbar, isSidebar, backTo = '/' } = props

  return (
    <nav className={cn('navbar', { '-full-navbar': isFullNavbar })}>
      {isSidebar ? (
        <button className="navbar__menu" onClick={toggleSidebarActive} type="button">
          <IconHamburger className="navbar__menu-icon" />
        </button>
      ) : (
        <Link className="navbar__menu" to={backTo}>
          <IconBack className="navbar__menu-icon" />
        </Link>
      )}
      <h1 className="navbar__title">{title}</h1>
    </nav>
  )
}

Navbar.propTypes = {
  title: PropTypes.string,
  toggleSidebarActive: PropTypes.func.isRequired,
  backTo: PropTypes.string,
  isSidebar: PropTypes.bool,
  isFullNavbar: PropTypes.bool,
}

export default Navbar
